export const OPEN_CRYPTA_BEHAVIORAL_EDITOR = 'OPEN_CRYPTA_BEHAVIORAL_EDITOR';
export type OPEN_CRYPTA_BEHAVIORAL_EDITOR = typeof OPEN_CRYPTA_BEHAVIORAL_EDITOR;

export interface OpenCryptaBehavioralEditor {
    type: OPEN_CRYPTA_BEHAVIORAL_EDITOR;
    id: string;
    itemsId: string[];
}

export function openCryptaBehavioralEditor(id: string, itemsId: string[]): OpenCryptaBehavioralEditor {
    return {
        type: OPEN_CRYPTA_BEHAVIORAL_EDITOR,
        id,
        itemsId
    };
}

export const CLOSE_CRYPTA_BEHAVIORAL_EDITOR = 'CLOSE_CRYPTA_BEHAVIORAL_EDITOR';
export type CLOSE_CRYPTA_BEHAVIORAL_EDITOR = typeof CLOSE_CRYPTA_BEHAVIORAL_EDITOR;

export interface CloseCryptaBehavioralEditor {
    type: CLOSE_CRYPTA_BEHAVIORAL_EDITOR;
    id: string;
    itemsId?: string[];
}

export function closeCryptaBehavioralEditor(id: string, itemsId?: string[]): CloseCryptaBehavioralEditor {
    return {
        type: CLOSE_CRYPTA_BEHAVIORAL_EDITOR,
        id,
        itemsId
    };
}

export const RESET_CRYPTA_BEHAVIORAL_EDITOR = 'RESET_CRYPTA_BEHAVIORAL_EDITOR';
export type RESET_CRYPTA_BEHAVIORAL_EDITOR = typeof RESET_CRYPTA_BEHAVIORAL_EDITOR;

export interface ResetCryptaBehavioralEditor {
    type: RESET_CRYPTA_BEHAVIORAL_EDITOR;
    id: string;
}

export function resetCryptaBehavioralEditor(id: string): ResetCryptaBehavioralEditor {
    return {
        type: RESET_CRYPTA_BEHAVIORAL_EDITOR,
        id
    };
}

export const CHANGE_ITEM_CRYPTA_BEHAVIORAL = 'CHANGE_ITEM_CRYPTA_BEHAVIORAL';
export type CHANGE_ITEM_CRYPTA_BEHAVIORAL = typeof CHANGE_ITEM_CRYPTA_BEHAVIORAL;

export interface ChangeItemCryptaBehavioral {
    type: CHANGE_ITEM_CRYPTA_BEHAVIORAL;
    id: string;
    itemId: string;
}

export function changeItemCryptaBehavioral(id: string, itemId: string): ChangeItemCryptaBehavioral {
    return {
        type: CHANGE_ITEM_CRYPTA_BEHAVIORAL,
        id,
        itemId
    };
}

export type CryptaBehavioralEditorAction =
    | CloseCryptaBehavioralEditor
    | ResetCryptaBehavioralEditor
    | OpenCryptaBehavioralEditor
    | ChangeItemCryptaBehavioral;
